const LIVESTREAM = "Livestream Signing";
const OFF_CAMERA = "Signed Off Camera";
const IN_PERSON = "In Person Signing";

const SIGNING_TYPE_BUMP = Object.freeze({
  [LIVESTREAM]: 500,
  [OFF_CAMERA]: 300,
});

/* product_type.bump_percentage is decimal(11,5), and apply_product_bump does its maths in
 * exact decimals. Floats overshoot a whole dollar now and then, so this works in integers. */
const PERCENT_SCALE = 100000;

const ceilDivide = (numerator, denominator) => {
  const quotient = Math.floor(numerator / denominator);

  return numerator > quotient * denominator ? quotient + 1 : quotient;
};

const marginFor = ({ sum, bumpPercentage }) => {
  const keep = Math.round((1 - bumpPercentage) * PERCENT_SCALE);

  return sum <= 0
    ? 0
    : ceilDivide(sum * (PERCENT_SCALE - keep), keep * 100) * 100;
};

const bumpOf = ({
  sum,
  signedType,
  bumpPercentage = 0,
  additionalBumpAmount = 0,
  fixedBump = false,
  productBump = 0,
}) =>
  fixedBump
    ? productBump
    : signedType === IN_PERSON || sum <= 0
    ? 0
    : marginFor({ sum, bumpPercentage }) +
      (SIGNING_TYPE_BUMP[signedType] ?? 0) +
      Math.max(0, additionalBumpAmount);

export const pricingFor = ({ splits, ...bumpFacts }) => {
  const price = splits.reduce((sum, split) => sum + Math.max(0, split), 0);
  const bump = bumpOf({ sum: price, ...bumpFacts });

  return { price, bump, total: price + bump };
};
